import { useTranslation } from 'react-i18next';
import { Chart as ChartJS, LinearScale, PointElement, Tooltip, Legend } from 'chart.js';
import { useEffect, useState } from 'react';
import { Bubble } from 'react-chartjs-2';
import bubblePalette from 'assets/js/palette';
import 'styles/global.css';

ChartJS.register(LinearScale, PointElement, Tooltip, Legend);

interface BubbleChartProps {
  chartData: any;
}

export const BubbleChart = ({ chartData }: BubbleChartProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<any>({});

  useEffect(() => {
    const optionsData = {
      responsive: true,
      maintainAspectRatio: true,
      scales: {
        y: {
          beginAtZero: true,
        },
        x: {
          beginAtZero: true,
        },
      },
      plugins: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 10,
          },
        },
      },
    };

    setOptions(optionsData);
  }, []);

  const getData = (chartData: any) => {
    const datasets: any[] = [];

    const bgColors = bubblePalette('cb-Custom1', chartData.length).map((hex: string) => '#' + hex);

    chartData.forEach((item: any, index: number) => {
      const plots = item.plots;

      for (const plot of plots) {
        datasets.push({
          label: item.headerName,
          fill: false,
          lineTension: 0.1,
          backgroundColor: bgColors[index],
          borderColor: bgColors[index],
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: [
            {
              x: plot.xAxis,
              y: plot.yAxis,
              r: plot.zAxis,
            },
          ],
        });
      }
    });

    return {
      labels: ['Data'],
      datasets,
    };
  };

  const data = getData(chartData);

  if (data) {
    return (
      <div className="custom-chart-size-2">
        <Bubble data={data} options={options} />
      </div>
    );
  }

  return (
    <>
      <div>
        <img className="empty-state-3" src="/icons/Empty_icon.svg" alt="empty visual" />
      </div>
      <div>
        <label className="label-style-4 mt-3">{t('EMPTY_STATE.NO_DATA_FOUND')}</label>
      </div>
      <div className="w-50">
        <label className="label-style-5 mt-3">
          Please add the data to view corresponding visualisation here
        </label>
      </div>
    </>
  );
};
